module.exports = __webpack_public_path__ + "static/img/Reid_H.3e1cbaa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Reid_H.jpg
// module id = Xhra
// module chunks = 0